import React, { useState } from 'react';
import { useLogin, useNotify, Notification } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, Paper, Typography, Container } from '@material-ui/core';
import Grid from '@mui/material/Grid';

import { urlLogo } from '../../utils/urlBase';

const useStyles = makeStyles((theme) => ({
    logo: {
        marginBottom: '1rem',
        width: '200px',
        height: 'auto', // mantiene le proporzioni dell'immagine
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    logoSpecifico: {
        marginBottom: '1rem',
        width: '45px',
        height: 'auto', // mantiene le proporzioni dell'immagine
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // backgroundColor: 'rgba(30,40,61)',
        padding: theme.spacing(3),
        border: 'none',  // Rimuove completamente tutti i bordi
        boxShadow: 'none', // Rimuove ombra
    },

    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        border: 0,
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    submit: {
        fontFamily: 'Roboto',
        letterSpacing: '2px',
        fontSize: '10px',
        margin: theme.spacing(0, 0, 0),
        backgroundColor: '#e85a2c', // Sfondo uguale a quello della pagina
        color: 'white', // Scritta bianca
        '&:hover': {
            backgroundColor: 'gray', // Puoi regolare questa tonalità per lo stato hover
        }
    },
    container: {
        // backgroundColor: 'rgba(30,40,61, 0.85)',
        backgroundColor: '#e85a2c',
        backgroundSize: 'cover',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
    },
    containerbg: {
        backgroundColor: 'white',
        backgroundSize: 'cover',
        height: '100vh',
        // display: 'flex',
        alignItems: 'center',
    },
    inputField: {
        '& label.Mui-focused': {
            color: '#e85a2c', // Colore dello sfondo
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'white',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: 'white',
        },
        '& .MuiInputBase-root': {
            color: 'white', // Colore del testo
            backgroundColor: 'gray', // Colore dello sfondo
            fontSize: '25px',
        },
        letterSpacing: '2px',
    },
    passwordLabel: {
        color: '#e85a2c',
        fontWeight: 'bold',
        textAlign: 'center',
        fontFamily: 'Roboto',
        fontSize: '20px',
        marginTop: theme.spacing(8),
        letterSpacing: '2px'
    },
    idLabel: {
        color: '#e85a2c',
        fontWeight: 'bold',
        textAlign: 'center',
        fontFamily: 'Roboto',
        fontSize: '20px',
        letterSpacing: '3px'
    },

}));

const MyLoginPage = ({ theme }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const login = useLogin();
    const notify = useNotify();
    const classes = useStyles();

    const handleSubmit = e => {
        e.preventDefault();
        login({ username: email, password }).catch(() =>
            notify('Email o password non valida')
        );
    };

    return (

        <Container maxWidth="xl" className={classes.containerbg}>
            <Container component="main" maxWidth="xs" className={classes.container}>
                <Grid container spacing={3} direction="column" >
                    <Grid item xs>
                        <Paper className={classes.paper} >
                            <Typography component="h1" variant="h5">
                                <img src={urlLogo} alt="Logo" className={classes.logo} />
                            </Typography>
                            <Typography component="h2" variant="h5">
                                Area Amministrativa
                            </Typography>
                            <form className={classes.form} onSubmit={handleSubmit}>
                                <Typography variant="h7" className={classes.idLabel}>
                                    LOGIN
                                </Typography>
                                <TextField
                                    // variant="outlined"
                                    variant="standard"
                                    margin="normal"
                                    required
                                    fullWidth
                                    // label="Email"
                                    type="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    className={classes.inputField}
                                />
                                <Typography variant="h7" className={classes.passwordLabel}>
                                    PASSWORD
                                </Typography>
                                <TextField
                                    // variant="outlined"
                                    variant="standard"
                                    margin="normal"
                                    required
                                    fullWidth
                                    // label="Password"
                                    type="password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    className={classes.inputField}
                                />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                >
                                    Accedi
                                </Button>
                            </form>
                        </Paper>
                        <Notification />
                    </Grid>
                </Grid>


            </Container>

        </Container>
    );
};

export default MyLoginPage;
